import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SpColorPickerModule } from '@components/sp-color-picker/src/sp-color-picker.module';

import { WebHoverEffectsComponent } from './web-hover-effects.component';
import { TranslateModule } from '@ngx-translate/core';
import { SpFormControlsModule } from '@components/sp-form-controls';
import { WebColorPickerComponent } from '@web/shared/components/web-color-picker/web-color-picker.component';

@NgModule({
    imports: [
        CommonModule,
        SpColorPickerModule,
        TranslateModule,
        SpFormControlsModule,
        WebColorPickerComponent,
        WebHoverEffectsComponent,
    ],
    exports: [WebHoverEffectsComponent],
})
export class WebHoverEffectsModule {}
